module.exports = __webpack_public_path__ + "img/1.53dbb160.jpg";